const constProd = require('./Constants.prod');
const constDev = require('./Constants.dev');
const constLocal = require('./Constants.local');

if (process.env.REACT_APP_NODE_ENV_EXP === 'production') {
  module.exports = constProd;
} else if (process.env.REACT_APP_NODE_ENV_EXP === 'development') {
  module.exports = constDev;
} else {
  module.exports = constLocal;
}
